export default __webpack_public_path__ + "static/niche@768-6b9f7a7d440b517989cd6bd26f897a79.webp";